import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OnboardingFormComponent } from './Components/onboarding-form/onboarding-form.component';
import { OnboardingStatusComponent } from './Components/onboarding-status/onboarding-status.component';

@NgModule({
  declarations: [
    OnboardingFormComponent,
    OnboardingStatusComponent
    // other components
  ],
  imports: [
    CommonModule,
    FormsModule,
    // other modules
  ],
})
export class OnboardModule { }